import { useState, useEffect, useContext } from 'react';
import { Context } from '@components/Context';
import { ProductCode } from '@contracts';
import { getNewProductPrice } from '@utils/price';

interface ProductPrices {
  [productCode: string]: number | null;
}

const useProductPrices = (productCodes: ProductCode[]): ProductPrices => {
  const { state } = useContext(Context);
  const { currency, country } = state;
  const [productPrices, setProductPrices] = useState<ProductPrices>({});

  useEffect(() => {
    const fetchPrices = async () => {
      const prices: ProductPrices = {};

      await Promise.all(
        productCodes.map(async (productCode) => {
          if (productCode) {
            const price = await getPriceForProduct(productCode);

            prices[productCode] = price !== -1 ? price : null;
          }
        })
      );

      setProductPrices(prices);
    };

    fetchPrices();
  }, [currency, productCodes]);

  const getPriceForProduct = async (productCode: string) => {
    const price = await getNewProductPrice(currency, country, productCode);
    return price ?? -1;
  };

  return productPrices;
};

export default useProductPrices;
